export class ObjetoComAdicionais {
  adicionais: any;
  valoresAdicionais: any;

  constructor() {
    this.adicionais = {}
  }

  atualizeTotal() {

  }

  calculePosicaoAdicionais(camposAdicionais: Array<any>) {
    let campoAdicional: any;
    let multiplaEscolha = 0, escolhaUnica = 0;
    for(campoAdicional of camposAdicionais) {
      if(campoAdicional.tipo === 'multipla-escolha') {
        campoAdicional.posicao = multiplaEscolha++
        this.setListaMultiplaEscolha(campoAdicional)
      } else {
        campoAdicional.posicao = escolhaUnica++
        this.adicionais[`meta_campo${campoAdicional.posicao}`] = {
          multiplicaQuantidadeProduto: campoAdicional.multiplicaQuantidadeProduto !== false
        }
      }
    }

    if(this.valoresAdicionais){
      this.valoresAdicionais.forEach( (valorAdicional: any) => {
        let i = 0;
        while (this.adicionais[String(`campo${i}`)]){
          let campoSimples = this.adicionais[String(`campo${i}`)];
          if(campoSimples.nome === valorAdicional.nome)
            this.adicionais[String(`escolhido_campo${i}`)] = campoSimples.id
          i++
        }
      })
    }
  }

  private setListaMultiplaEscolha(campoAdicional: any){
    if(!this.adicionais['lista' + campoAdicional.posicao]){
      this.adicionais['lista' + campoAdicional.posicao] = {}
      this.adicionais['lista' + campoAdicional.posicao].totalSelecionado = 0
      this.adicionais['lista' + campoAdicional.posicao].tipoDeCobranca = campoAdicional.tipoDeCobranca
      this.adicionais['lista' + campoAdicional.posicao].ordem = campoAdicional.ordem
    }

    this.adicionais['lista' + campoAdicional.posicao].multiplicaQuantidadeProduto =
      campoAdicional.multiplicaQuantidadeProduto !== false

    for(let opcao of campoAdicional.opcoesDisponiveis) {
      if(!this.adicionais['lista' + campoAdicional.posicao]['opcao_' + opcao.id]){
        this.adicionais['lista' + campoAdicional.posicao]['opcao_' + opcao.id] = {
          selecionada: false,
          opcao: opcao
        }

        if(campoAdicional.podeRepetirItem)
          this.adicionais['lista' + campoAdicional.posicao]['opcao_' + opcao.id].qtde = 0
      }
    }
  }

  prepareAdicionaisSabores(produto: any){
    let sabores  = (this as any).sabores;

    if(!sabores) return;

    let camposAdicionais = produto.camposAdicionais;
    let contadorMultipla = camposAdicionais.filter((adicional: any) => adicional.tipo === 'multipla-escolha').length ;
    let contadorAdicionalSimples = camposAdicionais.filter((adicional: any) => adicional.tipo === 'escolha-simples').length;

    let limparSabores  = true, proximaChave = contadorAdicionalSimples;

    while (limparSabores){
      let chave = String(`campo${proximaChave}`)
      if(this.adicionais[chave]){
        delete this.adicionais[chave]
        delete this.adicionais[String(`escolhido_campo${proximaChave}`)]
        delete this.adicionais[String(`meta_campo${proximaChave}`)]
        proximaChave++
      } else {
        limparSabores = false;
      }
    }

    limparSabores = true;
    proximaChave = contadorMultipla;

    while (limparSabores){
      let chave = String(`lista${proximaChave}`)
      if(this.adicionais[chave]){
        delete this.adicionais[chave]
        proximaChave++
      } else {
        limparSabores = false;
      }
    }

    sabores.forEach((sabor) => {
      if (sabor.produto !== produto.id) {
        for(let campoAdicionalSabor of sabor.camposAdicionais) {
          if(campoAdicionalSabor.tipo === 'multipla-escolha') {
            campoAdicionalSabor.posicao = contadorMultipla++
            this.setListaMultiplaEscolha(campoAdicionalSabor)

          } else if(campoAdicionalSabor.tipo === 'escolha-simples') {
            campoAdicionalSabor.posicao = contadorAdicionalSimples++
            this.adicionais[`meta_campo${campoAdicionalSabor.posicao}`] = {
              multiplicaQuantidadeProduto: campoAdicionalSabor.multiplicaQuantidadeProduto !== false
            }
          }
        }
      }
    })
  }

  configureAdicionais() {
    this.valoresAdicionais = []

    const nomesPropriedades = Object.keys(this.adicionais);
    for( let i = 0; i < nomesPropriedades.length; i++ ) {
      let nomeCampo = nomesPropriedades[i];
      if (nomeCampo.startsWith('lista')) {
        for(let nomeOpcao in this.adicionais[nomeCampo]) {
          if(nomeOpcao.startsWith('opcao') && this.adicionais[nomeCampo][nomeOpcao].selecionada) {
            const valor = this.obtenhaValorAdicional(this.adicionais[nomeCampo]);
            const entraUmaVezNoPedido = this.adicionais[nomeCampo].multiplicaQuantidadeProduto === false;

            this.valoresAdicionais.push({
              nome: this.adicionais[nomeCampo][nomeOpcao].opcao.nome,
              qtde: this.adicionais[nomeCampo][nomeOpcao].qtde || 1,
              valor: valor,
              entraUmaVezNoPedido: entraUmaVezNoPedido
            })
          }
        }
      }

      if(nomeCampo.startsWith('campo')) {
        const metaCampo = this.adicionais['meta_' + nomeCampo];

        this.valoresAdicionais.push({
          nome: this.adicionais[nomeCampo].nome,
          qtde: 1,
          valor: this.adicionais[nomeCampo].valor,
          entraUmaVezNoPedido: metaCampo && metaCampo.multiplicaQuantidadeProduto === false
        })
      }
    }
  }

  valideCampoAdicional(campoAdicional: any) {
    if(campoAdicional.esconder || campoAdicional.semOpcaoDisponivel) return true;

    if(campoAdicional.tipo === 'escolha-simples') {
      let valorCampo = this.adicionais['campo' + campoAdicional.posicao]

      if(campoAdicional.obrigatorio) {
        return valorCampo != null
      }
      return true
    }

    if(campoAdicional.tipo === 'multipla-escolha') {
      let valorCampo = this.adicionais['lista' + campoAdicional.posicao]

      let qtdMinima = campoAdicional.qtdMinima || 0;
      let qtdMaxima = campoAdicional.qtdMaxima || Object.keys(valorCampo).length;

      let qtdSelecionados = 0

      for(let nomeOpcao in  valorCampo) {
        let dadosOpcao = valorCampo[nomeOpcao]

        if(dadosOpcao && dadosOpcao.selecionada) {
          let qtde = dadosOpcao.qtde

          if(!qtde) qtde = 1

          qtdSelecionados += qtde
        }
      }

      if(qtdSelecionados === 0 && !campoAdicional.obrigatorio) return true;

      return qtdSelecionados >= qtdMinima && qtdSelecionados <= qtdMaxima
    }
  }

  obtenhaValorAdicionais() {
    let valorAdicionais = 0;

    for (let prop in this.adicionais) {
      if(prop.startsWith('campo') && this.adicionais[prop] != null)
        valorAdicionais += this.adicionais[prop].valor;
      else if(prop.startsWith('lista')) {
        let opcoes = this.adicionais[prop]

        valorAdicionais += this.obtenhaValorAdicional(opcoes)

      }
    }


    return valorAdicionais;
  }

  obtenhaValorAdicional(opcoes: any) {
    let valorAdicional = 0

    let tipoDeCobranca = opcoes.tipoDeCobranca

    switch(tipoDeCobranca) {
      case 'SOMA':
        for(let propInterna in opcoes) {
          if (opcoes[propInterna] && opcoes[propInterna].selecionada) {
            valorAdicional += opcoes[propInterna].valorTotal
          }
        }
        break;
      case 'MEDIA':
        let tot = 0;

        for(let propInterna in opcoes) {
          if (opcoes[propInterna] && opcoes[propInterna].selecionada) {
            tot += opcoes[propInterna].qtde;
            valorAdicional += opcoes[propInterna].valorTotal
          }
        }

        if(tot > 0)
          valorAdicional =  +((valorAdicional / tot).toFixed(2));
        break;
      case 'MAIOR':
        for(let propInterna in opcoes) {
          if (opcoes[propInterna] && opcoes[propInterna].selecionada) {
            if(opcoes[propInterna].valorTotal > valorAdicional)
              valorAdicional = opcoes[propInterna].valorTotal
          }
        }
        break;
    }

    return valorAdicional
  }
}
